import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assets/scss/portal.scss";
import { enableAllPlugins } from "immer";
import { DeviceInfo } from "./helper/Common";
import * as Sentry from "@sentry/react";
import { Offline } from "@sentry/integrations";

enableAllPlugins();

Sentry.setContext("deviceInfo", DeviceInfo());
Sentry.init({
  dsn: "https://a0e669fb5f574f099645f127976f3c6f@o801338.ingest.us.sentry.io/5802562",
  integrations: [new Offline()],
  enabled: process.env.NODE_ENV !== "development",
});

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
